export default {"src":"/_next/static/media/offer-loader.f4928d18.gif","height":576,"width":616,"blurWidth":0,"blurHeight":0};